import ExpandingTextArea from '@/components/ExpandingTextArea';
import { PROPOSALACTIONS } from '../reducers/proposalReducer';
import FileDropZone from './FileDropZone';
import { Proposal } from '@/interfaces/types';
import { useTranslation } from 'react-i18next';
import { Title, Group } from '@mantine/core';
import { useProposal } from '../context/ProposalContext';

export default function CaseDescription({ height }: { height: number | null }) {
  const { proposal, dispatchProposal } = useProposal();
  const { input } = proposal;
  const { t } = useTranslation();

  return (
    <>
      <Group>
        <Title order={4} mb="lg">
          {t('fileUpload')}
        </Title>
        {/* <Tooltip label={t('provideConstraints')} withArrow multiline w={220} position="right">
          <IconInfoCircle
            size={20}
            color="var(--mantine-primary-color-filled)"
            style={{ marginTop: 2 }}
          />
        </Tooltip> */}
      </Group>
      <FileDropZone
        onFilesProcessed={(summaries) => {
          dispatchProposal({
            type: PROPOSALACTIONS.SET_FIELD,
            field: 'input',
            value: proposal.input.length > 0 ? proposal.input + '\n\n' + summaries : summaries,
          });
        }}
      />

      <Group mt="lg">
        <Title order={4} mb="lg">
          {t('caseInfo')}
        </Title>
        {/* <Tooltip label={t('provideConstraints')} withArrow multiline w={220} position="right">
                <IconInfoCircle
                    size={20}
                    color="var(--mantine-primary-color-filled)"
                    style={{ marginTop: 2 }}
                />
                </Tooltip> */}
      </Group>
      <div style={{ position: 'relative' }}>
        <ExpandingTextArea
          value={input}
          placeholder={t('addYourInputTextHere')}
          onChange={(e) =>
            dispatchProposal({
              type: PROPOSALACTIONS.SET_FIELD,
              field: 'input',
              value: e.target.value,
            })
          }
          min_max_rows={height ? height / 40 : 20}
        />
      </div>
    </>
  );
}
